import React, { useEffect, useState } from "react";
import Divider from "@mui/material/Divider";
import ImageSlider from "../ReusableComponent/ImageSlider";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function MasterData({ equipmentDetails }) {
  const [imageList, setImageList] = useState([]);
  const { localization } = useLanguageContext();

  useEffect(() => {
    let image = [];
    if (equipmentDetails.anlagePhotos?.length > 0) {
      equipmentDetails.anlagePhotos.map((item) => {
        if (item.documentAsByte) {
          image.push({
            image: `data:image/jpg;base64,${item.documentAsByte}`,
          });
        }
      });
      setImageList(image);
    }
  }, [equipmentDetails]);
  return (
    <>
      <div className="container">
        <div className="row mb-3">
          <h2>
            <b>{localization.equipmentPhoto}</b>
          </h2>
        </div>
        {imageList?.length > 0 ? (
          <>
            <ImageSlider slides={imageList} handleImageSelection={() => {}} />
          </>
        ) : (
          <>
            <div className="masterData">{localization.noImageMsg}</div>
          </>
        )}
      </div>
      <Divider className="mt-5" />
      <div className="pt-3">
        <h2>
          <b>{localization.equipDetails}</b>
        </h2>
      </div>
      <div className="container masterData mt-3 mb-3">
        {equipmentDetails.length == 0 ? (
          <div>{localization.noDetails}</div>
        ) : (
          equipmentDetails.equipmentProperties?.map((details, index) => {
            return (
              <div key={"P_" + index} className="row p-3 mb-2">
                <div className="col-6 docNameCls">{details.id}</div>
                <div className="col-6 docNameCls">{details.text}</div>
              </div>
            );
          })
        )}
        {equipmentDetails.equipmentAttributes?.map((details, index) => {
          return (
            <div key={"A_" + index} className="row p-3 mb-2">
              <div className="col-6">{details.id}</div>
              <div className="col-6">{details.text}</div>
            </div>
          );
        })}
        {equipmentDetails.lastCheckDate && (
          <>
            {" "}
            <div className="row p-3 mb-2">
              <div className="col-6">{localization.lastCheckDate}</div>
              <div className="col-6">{equipmentDetails.lastCheckDate}</div>
            </div>
          </>
        )}
        {equipmentDetails.nextCheckDate && (
          <>
            {" "}
            <div className="row p-3 mb-2">
              <div className="col-6">{localization.nextCheckDate}</div>
              <div className="col-6">{equipmentDetails.nextCheckDate}</div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
